import { CreateBase, Form, useGetIdentity } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { FormToolbar } from "../layout/FormToolbar";

import { LoadInputs } from "./LoadInputs";

export const LoadCreate = () => {
  const { identity } = useGetIdentity();

  return (
    <CreateBase redirect="show">
      <div className="mt-2 flex flex-col gap-4 max-w-5xl">
        <h1 className="text-2xl font-bold">New Load</h1>
        <Form defaultValues={{ sales_owner_id: identity?.id }}>
          <Card>
            <CardContent className="pt-6">
              <LoadInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
    </CreateBase>
  );
};
